// Module
var code = "<article class=\"app-main__content-area content-area\"> <h1>Sorry, you don't have permissions to access this page</h1> <p class=\"mb-24 text-center\"> </p> </article> ";
// Exports
module.exports = code;